import { useContext } from 'react';
import { Button, Grid, Typography, MenuItem, TextField as MdTextField } from '@mui/material';
import { Form, Field, useFormikContext } from 'formik';
import { TextField } from 'formik-mui';
import { toolEditContext, toolSchema } from '../ToolEditContext';
import * as yup from 'yup';
import { useLocation } from 'react-router-dom';
import { applicationContext } from 'helpers/services';


let ToolForm = () => {
    let router = useLocation();

    let { toolTypologies } = useContext(applicationContext);
    let service = useContext(toolEditContext);

    let isNew = router.pathname.includes('/addnew');
    let title = isNew ? 'Nuovo Strumento' : `Modifica Strumento`;


    type Tool = yup.InferType<typeof toolSchema>;
    let form = useFormikContext<Tool>();


    return (
        <Form>
            <Grid container>
                <Grid item xs>
                    <Typography variant="h1">{title}</Typography>
                </Grid>
            </Grid>
            <Grid container>

                <Grid item xs={12} md={6}>
                    <Field
                        component={TextField}
                        name="serialNumber"
                        type="text"
                        label="Seriale"
                    />
                </Grid>
                <Grid item xs={12} md={6}>
                    <Field
                        component={TextField}
                        name="name"
                        type="text"
                        label="Nome"
                    />
                </Grid>
                <Grid item xs={12} md={12}>
                    <MdTextField
                        select
                        label="Tipologia"
                        value={form.values.toolTypologyId}
                        onChange={(e: any) => form.setFieldValue('toolTypologyId', e.target.value)}
                    >
                        {toolTypologies.map((t, ix) =>
                            <MenuItem key={ix} value={t.toolTypologyId}>{t.name}</MenuItem>
                        )}
                    </MdTextField>
                </Grid>
                <Grid item xs={12}>
                    <Field
                        component={TextField}
                        name="notes"
                        type="text"
                        label="Note"
                        multiline={true}
                        rows={4}
                    />
                </Grid>
            </Grid>

            <Grid container>
                <Grid item xs />
                <Grid item>
                    <Button variant="outlined" color="secondary" onClick={() => service.goBack()}>
                        Annulla
                    </Button>
                    <Button type="submit" variant="contained">
                        Salva
                    </Button>
                </Grid>
            </Grid>
        </Form>
    );
}

export default ToolForm;